<header mat-dialog-title class="u-flex-full">
  <span>
    {{'clients.Seleziona cliente' | translate}}
  </span>
</header>
<mat-dialog-content>
  <client-list [clients]="clients" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" [canAdd]="canAdd" (onAddClient)="addClient()" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectClient)="selectClient($event)"></client-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
